import moment from "moment";
import { isDate } from "./date-utils";

export const transformToFormIoValues = (values: any): void => {
    const transformToFormIoValue = (value: any) => {
        if (isDate(value)) {
            return moment.utc(value).local().toDate();
        } else {
            return value;
        }
    }

    Object.keys(values).forEach(key => {
        values[key] = transformToFormIoValue(values[key]);
    });
}

export const transformToDBValues = (values: any): void => {
    const transformValue = (value: any) => {
        if (isDate(value)) {
            return moment(value).utc().toISOString();
        } else {
            return value;
        }
    }

    Object.keys(values).forEach(key => {
        values[key] = transformValue(values[key]);
    });
}
